import data from "../../../../../packages/react/src/FormControl/FormControl.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import { MarkGithubIcon } from '@primer/octicons-react';
import { FormControl, TextInputWithTokens, Autocomplete, Select, Textarea, Checkbox, CheckboxGroup, Radio, RadioGroup, Text } from '@primer/react';
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  MarkGithubIcon,
  FormControl,
  TextInputWithTokens,
  Autocomplete,
  Select,
  Textarea,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Text,
  React
};